import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import type { Time } from '@jane/shared/types';

dayjs.extend(isBetween);

export const timeIsBetween = (
  time: Time,
  startTime: Time,
  endTime: Time
): boolean =>
  dayjs(time).isBetween(
    startTime,
    endTime,
    null,
    /** @see https://day.js.org/docs/en/plugin/is-between */
    '[]'
  );
